import React, { useEffect, useState } from 'react';
import PageCardItem from '../../Blocks/PageCardItem';
import PageCardItemModel from '../../Types/PageCardItemModel';
import clsx from 'clsx';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

interface MasonryItem {
  item: PageCardItemModel;
  isDoneLoading?: boolean;
}

interface MasonrySkeletonItem {
  aspectRatio?: string;
  isDoneLoading?: boolean;
}

const SkeletonItem = ({
  aspectRatio,
  isDoneLoading = false,
}: MasonrySkeletonItem) => (
  <div
    className={clsx(
      'transition-opacity duration-150',
      isDoneLoading ? 'opacity-0' : 'opactiy-100'
    )}
  >
    <div className="skeleton">
      <div
        className={clsx(
          'mb-4 h-full w-full rounded bg-gray-100 object-cover',
          aspectRatio
        )}
      ></div>
      <div className="flex flex-col items-start px-1">
        <h4 className="mb-1 inline-block h-6 w-full bg-gray-100 font-normal text-gray-900 transition hover:text-gray-700"></h4>
        <p className="block h-12 w-full overflow-hidden text-ellipsis break-words bg-gray-100 text-lg leading-[1.5em] text-gray-900 hover:text-gray-700"></p>
      </div>
    </div>
  </div>
);

const Item = ({ item, isDoneLoading }: MasonryItem) =>
  !item.skeleton ? (
    <PageCardItem item={item} aspectRatio={item.aspectRatio} />
  ) : (
    <SkeletonItem
      aspectRatio={item.aspectRatio}
      isDoneLoading={isDoneLoading}
    />
  );

interface PageCardItemListProps {
  items: PageCardItemModel[];
  isLoading?: boolean;
  className?: string;
  isInBlock?: boolean;
}

const PageCardItemList = ({
  items,
  isLoading = false,
  className,
  isInBlock = false,
}: PageCardItemListProps) => {
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);

  return (
    <div
      className={clsx(
        'transition-opacity duration-300',
        ready ? 'opacity-100' : 'min-h-screen opacity-0',
        isInBlock ? '' : 'container',
        className
      )}
    >
      {ready ? (
        <ResponsiveMasonry
          columnsCountBreakPoints={{ 0: 2, 1023: 3, 1439: 4 }}
        >
          <Masonry gutter="32px 16px">
            {items.map((item, idx) => (
              <Item
                key={
                  'masonry-' +
                  idx +
                  item.title +
                  item.aspectRatio +
                  item.url +
                  item.textExcerpt
                }
                item={item}
                isDoneLoading={!isLoading}
              />
            ))}
          </Masonry>
        </ResponsiveMasonry>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {items.map((item, idx) => (
            <Item
              item={item}
              key={'initial-' + idx}
              isDoneLoading={!isLoading}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PageCardItemList;
